<script setup lang="ts">
import { onUnmounted, useTemplateRef } from 'vue';
import { useRouter } from '#app/composables/router';
import { usePaneStore } from '#layers/workspace/stores/pane';
import WorkspaceChromeBreadcrumb from './WorkspaceChromeBreadcrumb.vue';
import WorkspaceChromeSidebarProvider from './WorkspaceChromeSidebarProvider.vue';

const paneContainerRef = useTemplateRef('paneContainer');
const paneStore = usePaneStore();
const router = useRouter();

paneStore.syncAvailablePaneWidth(paneContainerRef);

const unregisterAfterEach = router.afterEach(() => {
	if (!paneStore.sidebarUseSplitPanel) {
		paneStore.toggleSidebar(false);
	}
});

onUnmounted(unregisterAfterEach);
</script>

<template>
	<div ref="paneContainer" class="size-full">
		<WorkspaceChromeSidebarProvider>
			<template #sidebar>
				<slot name="sidebar" />
			</template>

			<template #header-title>
				<slot name="header-title">
					<WorkspaceChromeBreadcrumb />
				</slot>
			</template>

			<div class="size-full pb-safe">
				<slot />
			</div>
		</WorkspaceChromeSidebarProvider>
	</div>
</template>
